import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { getWaitingOrders } from '../ordersThunk';
import { OrdersState } from '../types';
import { CustomError } from 'shared/api';

export const getWaitingOrdersReducer = (builder: ActionReducerMapBuilder<OrdersState>) => {
	builder
		.addCase(getWaitingOrders.pending, state => {
			state.loadingWaitingOrders = true;
			state.waitingOrders = [];
		})
		.addCase(getWaitingOrders.fulfilled, (state, action) => {
			state.loadingWaitingOrders = false;
			const results = action.payload.results;

			if (!results.length) {
				state.waitingOrders = [];
			}

			const page = action.meta.arg.page;
			if (page && page > 1) {
				state.waitingOrders = state.waitingOrders.concat(results);
			} else if (results.length) {
				state.waitingOrders = results;
			}

			state.stats = action.payload.stats;

			state.error = null;
		})

		.addCase(getWaitingOrders.rejected, (state, action) => {
			state.loadingWaitingOrders = false;
			state.stats = {
				appointments: 'error',
				participants: 'error',
			};
			state.error = action.payload as CustomError;
		})
};